// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bread-crumb {
  padding: 0 0.25rem 0.125rem;
}
.bread-crumb p {
  display: inline-block;
  margin: 0;
  cursor: default;
}
.bread-crumb .spacer {
  color: #adb5bd;
  vertical-align: middle;
}
.bread-crumb .level {
  display: inline-block;
  padding: 0 0.625rem;
  color: #456c9b;
  cursor: pointer;
  max-width: 280px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  vertical-align: middle;
}
.bread-crumb .level:hover:not(.current) {
  color: rgb(53.2901785714, 83.4107142857, 119.7098214286);
  text-decoration: none;
}
.bread-crumb .level.current {
  color: #adb5bd;
  cursor: default;
}
@media (max-width: 750px) {
  .bread-crumb span,
  .bread-crumb a {
    display: block;
  }
  .bread-crumb .spacer,
  .bread-crumb .current {
    display: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/shared/breadcrumb/breadcrumb.component.scss","webpack://./src/assets/styles/variables.scss"],"names":[],"mappings":"AAGA;EACE,2BAAA;AAFF;AAIE;EACE,qBAAA;EACA,SAAA;EACA,eAAA;AAFJ;AAKE;EACE,cCGO;EDFP,sBAAA;AAHJ;AAME;EACE,qBAAA;EACA,mBAAA;EACA,cCjBQ;EDkBR,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;AAJJ;AAMI;EACE,wDAAA;EACA,qBAAA;AAJN;AAOI;EACE,cClBK;EDmBL,eAAA;AALN;AASE;EACE;;IAEE,cAAA;EAPJ;EAUE;;IAEE,aAAA;EARJ;AACF","sourcesContent":["@import 'variables';\n@import 'functions';\n\n.bread-crumb {\n  padding: 0 rem(4) rem(2);\n\n  p {\n    display: inline-block;\n    margin: 0;\n    cursor: default;\n  }\n\n  .spacer {\n    color: $gray-500;\n    vertical-align: middle;\n  }\n\n  .level {\n    display: inline-block;\n    padding: 0 rem(10);\n    color: $dark-blue;\n    cursor: pointer;\n    max-width: 280px;\n    overflow: hidden;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    vertical-align: middle;\n\n    &:hover:not(.current) {\n      color: darken($dark-blue, 10%);\n      text-decoration: none;\n    }\n\n    &.current {\n      color: $gray-500;\n      cursor: default;\n    }\n  }\n\n  @media (max-width: 750px) {\n    span,\n    a {\n      display: block;\n    }\n\n    .spacer,\n    .current {\n      display: none;\n    }\n  }\n}\n","@import './functions.scss';\n\n$standard-blue: #54b0cb;\n$dark-blue: #456c9b;\n$green: #6fa163;\n$yellow: #f6af0b;\n$red: #e84e25;\n$min-contrast-ratio: 3;\n\n$enable-validation-icons: false;\n\n$white: #fff !default;\n$gray-100: #f8f9fa !default;\n$gray-200: #e9ecef !default;\n$gray-300: #dee2e6 !default;\n$gray-400: #ced4da !default;\n$gray-500: #adb5bd !default;\n$gray-550: #8d959d;\n$gray-600: #6c757d !default;\n$gray-700: #495057 !default;\n$gray-800: #343a40 !default;\n$gray-900: #212529 !default;\n$black: #000 !default;\n\n$bg-color: #778899;\n$primary: $dark-blue;\n$secondary: $standard-blue;\n$body-color: $gray-600;\n$light: $gray-300;\n$text-muted: $gray-550;\n\n$h1-font-size: rem(28);\n$h2-font-size: rem(24);\n$h3-font-size: rem(19);\n\n$input-btn-padding-y: 0.1875rem;\n$input-btn-padding-x: 0.375rem;\n$input-color: $gray-600;\n$input-placeholder-color: $gray-500;\n\n$grid-gutter-width: 12px;\n$border-color: $gray-200;\n\n// table\n$table-cell-padding: 0.625rem;\n\n$banner-height: rem(60);\n\n@import '../../../node_modules/bootstrap/scss/_functions';\n@import '../../../node_modules/bootstrap/scss/_variables';\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
